module.exports = __webpack_public_path__ + "img/logo.eecd3675.png";